<template>
  <v-card class="quote-container">
    <v-row no-gutters>
      <v-col cols="7" sm="7" md="7">
        <v-card-title>
          <a
            class="quote-title text-decoration-underline font-weight-bold"
            :class="title"
            >{{ title }}</a
          >assist</v-card-title
        >
        <v-card-text class="card-description">
          <p>
            {{ text }}
          </p>
          <router-link
            :to="{ name: 'LearnMore' }"
            class="text-decoration-underline learn-more"
            >Learn More</router-link
          >
        </v-card-text>
      </v-col>
      <v-col
        cols="5"
        sm="5"
        md="5"
        class="pl-2 pr-2 pr-lg-8 d-flex align-center"
      >
        <v-img
          :src="require(`@/assets/${this.quote.imageUrl}`)"
          aspect-ratio="1"
          alt="estimated insurance required input"
          class="insurance-img pr-2"
          :class="{ 'insurance-img-custom-xs': $vuetify.breakpoint.xs }"
          contain
        />
      </v-col>
    </v-row>
    <div class="pl-4 pr-4">
      <v-divider />
    </div>
    <v-card-text class="info-section">
      <v-row no-gutters>
        <InsuranceCardEducationFooter
          v-if="quote.productCode === 'EC_D'"
          :quote="quote"
          :people-relations="peopleRelations"
        />
        <InsuranceCardFooter v-else :quote="quote" />
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import InsuranceCardFooter from './InsuranceCardFooter.vue';
  import InsuranceCardEducationFooter from './InsuranceCardEducationFooter.vue';

  export default {
    name: 'InsuranceCard',
    components: {
      InsuranceCardFooter,
      InsuranceCardEducationFooter,
    },
    props: {
      quote: {
        required: false,
        type: Object,
      },
      peopleRelations: {
        type: Object,
        required: true,
      },
    },
    computed: {
      title() {
        switch (this.quote.productCode) {
          case 'COC':
            return 'cost';
          case 'CAC':
            return 'cash';
          case 'DAC':
            return 'debt';
          case 'EC_D':
            return 'edu';
          default:
            break;
        }
      },
      text() {
        switch (this.quote.productCode) {
          case 'COC':
            return "There are costs associated with winding up your estate such as Executor's fees and administration costs. This cover will make sure cash is available to cover these expenses.";
          case 'CAC':
            return 'When you pass away, your family might need money immediately to cover day to day expenses e.g. groceries. This cover gives your loved ones instant access to money.';
          case 'DAC':
            return 'You may have outstanding loans on your house or car. This cover will make sure you have sufficient cash to pay off these loans should you pass away.';
          case 'EC_D':
            return 'Give your children the future they deserve by protecting their education. This cover will pay an annual amount to help with educational costs should you pass away.';
          default:
            break;
        }
      },
    },
  };
</script>

<style lang="scss">
  .quote-container {
    border-radius: 14px !important;
    .card-title {
      padding-right: 0px;
    }

    .quote-title {
      font-size: 20px;
    }

    .cost {
      color: var(--v-cost-orange-base);
    }

    .edu {
      color: var(--v-education-blue-base);
    }

    .cash {
      color: var(--v-cash-green-base);
    }

    .debt {
      color: var(--v-debt-brown-base);
    }

    .info-section {
      span {
        font-size: 13px;
      }
    }

    .v-card__title {
      font-size: 24px;
      a {
        font-size: 24px;
      }
      padding-left: 24px;
      padding-right: 20px;
    }

    .card-description {
      padding-left: 24px;
      padding-right: 20px;
    }

    .insurance-img-custom-xs {
      max-width: 75px;
    }
  }
  @media screen and (max-width: 960px) and (min-width: 600px) {
    .quote-container {
      .v-card__title {
        font-size: 18px !important;
        a {
          font-size: 18px !important;
        }
        padding-left: 24px;
        padding-right: 20px;
      }
    }
    .card-description {
      font-size: 15px;
    }
  }

  @media screen and (max-width: 599px) and (min-width: 0px) {
    .quote-container {
      .v-card__title {
        font-size: 12px !important;
        a {
          font-size: 12px !important;
        }
        padding-left: 12px;
        padding-right: 0px;
        padding-top: 12px;
        padding-bottom: 0;
      }
    }
    .card-description {
      padding-left: 12px !important;
      padding-right: 4px !important;
      p {
        font-size: 10px;
        line-height: 12px;
      }
    }
  }
</style>
